// Sommaire des guides. Une carte par article, dans l'ordre du fichier
// src/content/guides/index.js — l'ordre y est éditorial, pas alphabétique.
import { Link } from 'react-router-dom'
import Navbar from '../components/urself/Navbar'
import Footer from '../components/urself/Footer'
import GUIDES, { CATEGORIES } from '../content/guides'
import { useT } from '../lib/i18n'
import { useSeo, breadcrumbLd } from '../lib/seo'

export default function Guides () {
  const t = useT()
  const g = t.seo.guides

  useSeo({
    title: g.title,
    description: g.description,
    path: '/guides',
    jsonLd: [
      breadcrumbLd([{ name: g.crumbHome, path: '/' }, { name: g.crumbGuides, path: '/guides' }]),
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: g.title,
        url: 'https://selfcntrl.com/guides',
        hasPart: GUIDES.map(x => ({
          '@type': 'Article',
          headline: x.title,
          url: `https://selfcntrl.com/guides/${x.slug}`
        }))
      }
    ]
  })

  return (
    <div className="u">
      <Navbar />

      <main className="u-legal u-guide">
        <div className="u-wrap">
          <header className="u-legal__head">
            <h1 className="u-h2 u-h2--caps">{g.h1}</h1>
            <p className="u-legal__intro">{g.lead}</p>
          </header>

          {CATEGORIES.map((c, i) => {
            const last = i === CATEGORIES.length - 1
            const items = GUIDES.filter(x => x.category === c.id || (last && !CATEGORIES.some(k => k.id === x.category)))
            if (!items.length) return null
            return (
              <section key={c.id} className="u-gsec" id={c.id}>
                <h2 className="u-gsec__h">{c.title}</h2>
                <p className="u-gsec__p">{c.lead}</p>
                <div className="u-guides">
                  {items.map(x => (
                    <Link key={x.slug} to={`/guides/${x.slug}`} className="u-gcard">
                      {x.kicker && <span className="u-gcard__k">{x.kicker}</span>}
                      <span className="u-gcard__t">{x.title}</span>
                      <span className="u-gcard__p">{x.description}</span>
                      <span className="u-gcard__m">
                        {x.minutes ? g.minutes(x.minutes) : ''}
                        <span className="u-gcard__go">{g.readMore} →</span>
                      </span>
                    </Link>
                  ))}
                </div>
              </section>
            )
          })}
        </div>
      </main>

      <Footer />
    </div>
  )
}
